<template>
  <v-expansion-panel>
    <v-expansion-panel-content v-if="node.meta">
      <div slot="header">Model Info</div>
      <v-card>
        <v-card-text>
          <v-text-field label="Author" :value="node.meta.authorName" readonly />
          <v-text-field label="Description" :value="node.meta.description" readonly />
          <a v-if="polyUrl" :href="polyUrl" target="_blank">View in poly</a>
        </v-card-text>
      </v-card>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
export default {
  name: 'ThreeGLTFSettings',
  props: {
    node: {
      type: Object,
      required: true
    }
  },
  computed: {
    polyUrl () {
      if (!this.node.meta || !this.node.meta.name) { return }
      return this.node.meta.name.replace('assets', 'https://poly.google.com/view')
    }
  }
}
</script>

<style>

</style>
